@let summary = overviewDashboardService.summary$ | async;
@let formattedTotalPower = summary?.totalPower | power: 'kw';
@let formattedFreePower = summary?.freePower | power: 'kw';

<div class="panel overview-dashboard">
  <div class="overview-dashboard__heading">
    <h3 class="overview-dashboard__heading-title">
      {{ 'monitoring.dashboard.overview-dashboard.title' | translate }}
    </h3>
    <lib-button
      class="overview-dashboard__heading-modal-button"
      buttonStyle="transparent-tertiary"
      buttonTextAlign="right"
      buttonSize="large"
      (click)="openOverviewDashboardModal('monitoring.dashboard.overview-dashboard.modal.title')"
    >
      <lib-svg-icon
        icon="widget-add"
        size="24"
      />
      <span>{{ 'monitoring.dashboard.overview-dashboard.modal-button' | translate }}</span>
    </lib-button>
  </div>

  <div class="overview-dashboard__content">
    <div class="overview-dashboard__card">
      <h4 class="overview-dashboard__title">
        {{ 'monitoring.dashboard.overview-dashboard.card.devices.title' | translate }}
      </h4>
      <div class="overview-dashboard__vertical-content">
        <div class="overview-dashboard__content-row">
          <span class="overview-dashboard__value">{{
            summary?.activeDeviceCount | formattedCount
          }}</span>
        </div>
        <div class="overview-dashboard__bottom-row">
          <span class="overview-dashboard__text">{{
            'monitoring.dashboard.overview-dashboard.card.devices.in-work' | translate
          }}</span>
          <div class="overview-dashboard__badge">
            <span class="overview-dashboard__badge-number">{{
              summary?.freeDeviceCount | formattedCount
            }}</span>
            <span class="overview-dashboard__badge-text">{{
              'monitoring.dashboard.overview-dashboard.card.devices.free' | translate
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="overview-dashboard__card">
      <h4 class="overview-dashboard__title">
        {{ 'monitoring.dashboard.overview-dashboard.card.hashrate.title' | translate }}
      </h4>
      <div class="overview-dashboard__vertical-content">
        <div class="overview-dashboard__content-row">
          <div class="overview-dashboard__value-row overview-dashboard__value-row--hashrate">
            <span class="overview-dashboard__value">{{
              summary?.totalHashrate | hashrate: 'onlyDigit' : hashrateDecimalRule
            }}</span>
            <span class="overview-dashboard__unit">{{
              summary?.totalHashrate | hashrate: 'onlyLabel'
            }}</span>
          </div>
          <div class="overview-dashboard__value-row overview-dashboard__value-row--hashrate">
            <span class="overview-dashboard__value">{{
              summary?.totalSolHashrate | solHashrate: 'onlyDigit' : hashrateDecimalRule
            }}</span>
            <span class="overview-dashboard__unit">{{
              summary?.totalSolHashrate | solHashrate: 'onlyLabel'
            }}</span>
          </div>
        </div>
        <div class="overview-dashboard__bottom-row">
          <span class="overview-dashboard__text">{{
            'monitoring.dashboard.overview-dashboard.card.hashrate.total' | translate
          }}</span>
        </div>
      </div>
    </div>

    <div class="overview-dashboard__card">
      <h4 class="overview-dashboard__title">
        {{ 'monitoring.dashboard.overview-dashboard.card.power.title' | translate }}
      </h4>
      <div class="overview-dashboard__horizontal-content">
        <div class="overview-dashboard__content-column overview-dashboard__content-column--power">
          <div class="overview-dashboard__value-row">
            <span class="overview-dashboard__value">{{ formattedTotalPower.value }}</span>
            @if (formattedTotalPower.unit) {
              <span class="overview-dashboard__unit">{{
                formattedTotalPower.unit | translate
              }}</span>
            }
          </div>
          <span class="overview-dashboard__text">{{
            'monitoring.dashboard.overview-dashboard.card.power.total' | translate
          }}</span>
        </div>
        <div class="overview-dashboard__content-column overview-dashboard__content-column--power">
          <div class="overview-dashboard__value-row">
            <span class="overview-dashboard__value">{{ formattedFreePower.value }}</span>
            @if (formattedFreePower.unit) {
              <span class="overview-dashboard__unit">{{
                formattedFreePower.unit | translate
              }}</span>
            }
          </div>
          <span class="overview-dashboard__text">{{
            'monitoring.dashboard.overview-dashboard.card.power.free' | translate
          }}</span>
        </div>
      </div>
    </div>

    <div class="overview-dashboard__card">
      <h4 class="overview-dashboard__title">
        {{ 'monitoring.dashboard.overview-dashboard.card.temperature.title' | translate }}
      </h4>
      <div class="overview-dashboard__horizontal-content">
        <div class="overview-dashboard__content-column">
          <div class="overview-dashboard__value-row">
            <span class="overview-dashboard__value">{{
              summary?.averageTemperature | formattedTemperature
            }}</span>
            <span class="overview-dashboard__unit overview-dashboard__unit--temperature"
              >&deg;C</span
            >
          </div>
          <span class="overview-dashboard__text">{{
            'monitoring.dashboard.overview-dashboard.card.temperature.average' | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
